import React from 'react';
import { stopApiSession } from '../../../services/apiClient'

export default class LogoutButton extends React.Component {
    constructor(args) {
        super(args);
    }

    onLogout() {
        stopApiSession();
    }

    render() {
        return (
            <li>
                <a href="#" onClick={() => this.onLogout()}>
                    <i className="fa fa-sign-out"></i>
                </a>
            </li>
        );
    }
}


// WEBPACK FOOTER //
// ./App/containers/header/user/logoutButton.jsx